import { useNavigation } from "./useNavigation";

/**
 * @deprecated use package "@khol/react/hooks" instead
 */
export function createNavigationHook<T extends string>() {
  // Return a function that wraps useNavigation with predefined navigation paths
  return function useTypedNavigation(locale?: string) {
    return useNavigation<T>(locale);
  };
}
